import { fk, attr } from 'redux-orm'
import Base from './Base'

class MatchReview extends Base {
  static get fields() {
    return {
      id: attr(),
      matchProposalId: fk({to: 'matchProposal', as: 'matchProposal', relatedName: 'matchReview'}),
      chosenDossierId: fk({to: 'dossier', as: 'chosenDossier'}),
      chosenConsultationTypeId: fk({to: 'consultationType', as: 'chosenConsultationType'}),
    }
  }
}

MatchReview.modelName = 'matchReview'

export default MatchReview
